import {
    GET_ANNOUNCEMENTS,
    GET_ANNOUNCEMENTS_SUCCESS,
    GET_ANNOUNCEMENTS_FAILURE,
    SET_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP,
    SET_ROUTE_PATH_FOR_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP,
    SET_ANNOUNCEMENT_CU_IN_PROGRESS,
} from '../actions';

const initialState = {
    loading: false,
    announcements: [],
    statusCode: '',
    statusMessage: '',
    unsavedAnnouncementChangesPopUp: false,
    routePathForAnnouncementUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    announcementCUInProgress: true,
};

const AnnoucementsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ANNOUNCEMENTS:
            return {
                ...state,
                loading: true,
            };
        case GET_ANNOUNCEMENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                announcements: action.payload.announcements,
                statusCode: action.payload.statusCode,
                statusMessage: action.payload.statusMessage,
            };
        case GET_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                loading: false,
                statusCode: action.payload.statusCode,
                statusMessage: action.payload.statusMessage,
            };
        case SET_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedAnnouncementChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForAnnouncementUnsavedChangesPopUp: action.payload,
            };
        case SET_ANNOUNCEMENT_CU_IN_PROGRESS:
            return {
                ...state,
                announcementCUInProgress: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default AnnoucementsReducer;
